import { Grid2, Link } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { createCompanyLogoUrl } from "../../helpers/urlBuilder";
import { stringToHtml } from "../../helpers/string";
import CertifiedLogo from "../CertifiedLogo";
import TableCell from "../CertificateTable/TableCell";

import classes from './index.module.scss';

const CompanyOverview = ({ company }) => {
  return (
    <TableCell center container size={12} fullWidth className={classes.companyCell}>
      <Grid2 container direction='row' size={12} className={classes.companyContainer}>
        <Grid2 className={classes.rest}>
          <Grid2 className={classes.companyLogoContainer}>
            <img src={createCompanyLogoUrl(company.id)} alt={company.name} className={classes.companyLogo} />
          </Grid2>
          <Grid2 className={classes.column}>
            <Grid2 size={12} dangerouslySetInnerHTML={{ __html: stringToHtml(company.description) }} />
            {
              company.webSite ? (
                <Grid2 size={12} className={classes.linkContainer}>
                  <Link href={company.webSite} target="_blank" className={classes.link}>{company.webSite}</Link>
                </Grid2>
              ) : null
            }
          </Grid2>
          <Grid2 className={classes.column}>
            <Grid2 size={12} dangerouslySetInnerHTML={{ __html: stringToHtml(company.contact) }} />
            {
              company.email ? (
                <Grid2 size={12} container className={classes.emailContainer}>
                  <EmailOutlinedIcon className={classes.emailIcon} />
                  <Link href={'mailto:' + company.email} className={classes.email}>{company.email}</Link>
                </Grid2>
              ) : null
            }
          </Grid2>
        </Grid2>
        <Grid2 className={classes.ghmtLogo}>
          <CertifiedLogo />
        </Grid2>
      </Grid2>
    </TableCell>
  )
}

export default CompanyOverview;